import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Design } from './components';
import useTemplate from './useTemplate';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const TemplateDesign = props => {
  const { className, staticContext, ...rest } = props;
  const template = useTemplate();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Design
          template={template}
          showNav={true}
          back="/attachment-templates/details"
        />
      </div>
    </div>
  );
};

export default TemplateDesign;
